import { memo } from 'react';
import styled from '@emotion/styled';
import { CopyAction, TableSelectable, tokens, Tooltip } from '@hotjar/hotsauce';
import { MessageForUnknownData } from '../common';

export const ContainerURL = styled.span`
  align-items: center;
  display: flex;

  &:hover .copy-action {
    visibility: visible;
  }
`;

export const TruncatedURL = styled.span`
  ${tokens.truncateText()};
  display: inline-block;
  max-width: 200px;
`;

export const HiddenCopyAction = styled(CopyAction)`
  visibility: hidden;
`;

interface URLCellProps {
  url: string | null;
  formatUrlFn?: (url: string) => string;
  copyActionDescription: string;
}

const RecordingsURLCell = ({
  url,
  formatUrlFn,
  copyActionDescription,
}: URLCellProps): JSX.Element => (
  <TableSelectable.Cell>
    {url ? (
      <ContainerURL>
        <Tooltip text={url} placement="top" appendTo="parent">
          <TruncatedURL>{formatUrlFn ? formatUrlFn(url) : url}</TruncatedURL>
        </Tooltip>
        <HiddenCopyAction
          className="copy-action"
          toCopy={url}
          description={copyActionDescription}
        />
      </ContainerURL>
    ) : (
      <MessageForUnknownData>Unknown</MessageForUnknownData>
    )}
  </TableSelectable.Cell>
);

export const URLCell = memo(RecordingsURLCell);
